export default "__VITE_ASSET__12b6799c__"